var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('echarts',{ref:"echarts",staticClass:"chart-box-wrap",attrs:{"options":_vm.options,"theme":_vm.chartTheme,"auto-resize":true},on:{"click":function($event){_vm.chartClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }